import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Pencil = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 21 21">
      <path d="M6.121,17.31l-4.088,1.338l1.363,-4.017l10.339,-10.165l2.725,2.679l-10.339,10.165Zm13.064,-12.844l-1.817,1.787l-2.725,-2.679l1.817,-1.787l2.725,2.679Zm-2.725,-4.466l-14.187,13.951l-2.273,6.696l6.814,-2.233l14.186,-13.948l-4.542,-4.466l0.002,0Z" />
    </svg>
  );
};

Pencil.defaultProps = {
  width: '100%',
  height: '100%',
};
export default Pencil;
